import { defineMessages } from 'react-intl';

export default defineMessages({
  watchingButtonText: {
    id: 'frontbucket.profile.repositories.filter.watching',
    description: 'Descriptive text of watching filter',
    defaultMessage: 'Watching',
  },
});
